import { useContext } from 'react'
import { Plus } from '../../../icons'
import { NumberInputContext } from '../NumberInputContext'
import { StepperPrimitive } from '../primitives'

export const Increment = () => {
  const { increment, round, variant, isIncrementDisabled, isDisabled } =
    useContext(NumberInputContext)

  return (
    <StepperPrimitive.IconButton
      size="sm"
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        increment()
      }}
      right
      round={round}
      variant={variant === 'default' ? undefined : 'outlineDark'}
      disabled={isIncrementDisabled || isDisabled}
    >
      <Plus />
    </StepperPrimitive.IconButton>
  )
}
